import {lazy} from 'react'

// Async Handler Components

export const ElaAdaptiveSkillsPracticePreviewPrintAssignmentHandler = lazy(
  () => import('./../../../../../ela/adaptive-skills/components/preview-print-assignment'),
)

export const ElaTargetedSkillsPracticePreviewPrintAssignmentHandler = lazy(
  () => import('./../../../../../ela/targeted-skills/components/preview-print-assignment'),
)

export const ElaArticlePreviewPrintAssignmentHandler = lazy(
  () => import('./../../../../../ela/articles/components/preview-print-assignment'),
)

export const ElaFocusSkillsPracticePreviewPrintAssignmentHandler = lazy(
  () => import('./../../../../../ela/focus-skills/components/preview-print-assignment'),
)
